<template>
  <div class="aifv-list">
    <div class="aifv-div-top">
      <form action="/" class="logo-container">
        <van-search
          v-model="searchValue"
          right-icon=""
          shape="round"
          placeholder="搜索内容"
          @search="onCourseSearchEnter"
          :clearable="true"
          clear-trigger="always"
          @clear="clearSearchValue"
        >
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
    </div>
    <div class="aifv-list-container" v-if="isNone && employeeList.length > 0">
      <van-list
        v-model="postState.loading"
        :finished="postState.finished"
        :finished-text="postState.finishText"
        @load="handleEmployee"
      >
        <div
          class="item-container"
          v-for="item in employeeList"
          :key="item.id"
          @click="handleItemClick(item)"
        >
          <img
            :src="item.headPicUrl"
            v-if="item.headPicUrl"
            class="item-cover"
            alt=""
          />
          <img
            src="@/assets/images/aifv/img14.png"
            v-else
            class="item-cover"
            alt=""
          />
          <div class="item-info">
            <div class="item-title">{{ item.hcpName }}</div>
            <div class="item-tags">
              <img
                src="@/assets/images/cartojourney/img24.png"
                class="icon-tag"
                alt=""
              />
              {{ item.currentStageCj }}
            </div>
            <div class="item-txt">{{ item.hospitalName }}</div>
          </div>
          <div
            class="arrow-btn arrow-btn2"
            v-if="`${item.customizedJourneyStatus}` === '1'"
          >
            {{ item.customizedJourneyStatusText }}
            <img
              src="@/assets/images/cartojourney/img21.png"
              class="item-arrow"
              alt=""
            />
          </div>
          <div
            class="arrow-btn arrow-btn1"
            v-if="`${item.customizedJourneyStatus}` === '-1'"
          >
            {{ item.customizedJourneyStatusText }}
            <img
              src="@/assets/images/cartojourney/img23.png"
              class="item-arrow"
              alt=""
            />
          </div>
          <div
            class="arrow-btn arrow-btn3"
            v-if="`${item.customizedJourneyStatus}` === '0'"
          >
            {{ item.customizedJourneyStatusText }}
            <img
              src="@/assets/images/cartojourney/img22.png"
              class="item-arrow"
              alt=""
            />
          </div>
        </div>
      </van-list>
    </div>
    <div class="empty-block" v-else-if="!isNone">
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{cDialog.content}}</div>
    </custom-dialog>
  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import { customizedChangeSuger, employeeHcp } from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
import CustomDialog from './components/CustomDialog.vue'
// import {CDROLES} from '@/utils/configRoles.js'
import { whiteUser } from '@/api/grade'
const UserProfile = {
  name: 'aifvList',
  components: {
    CustomDialog
  },
  data() {
    return {
      searchValue: '',
      employeeList: [],
      postState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了',
      },
      isNone: true,
      customizedObj: {},
      isWhiteUser: false,
      cDialog: {
        title: '标题',
        visible: false,
        content: '',
        confirm: () => {
        },
        cancel: () => {
        },
        close: () => {
        },
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    userRole() {
      return this.isWhiteUser ? 'CS' : sessionStorage.getItem('userRole')
    },
    EDITORROLES() {
      return JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).EDITORROLES
    },
  },
  mounted() {
    sessionStorage.removeItem('surgeonIepOpenId')
    sessionStorage.removeItem('journeyStage')
    this.handleEmployee()
    whiteUser({email: this.userInfo.email}).then(resUser => {
      this.isWhiteUser = resUser.data
      if (this.isWhiteUser) {
        sessionStorage.setItem('isWhiteUser', JSON.stringify(resUser.data))
      }
    }).catch(err => console.log(err))
  },
  methods: {
    handleItemClick(item) {
      // let isUserRole = CDROLES.includes(this.userRole)
      let isUserRole = !(this.EDITORROLES.includes(this.userRole))
      if (isUserRole && `${item.customizedJourneyStatus}` !== '1') {
        this.$toast('请查看“已定制”的术者CJ!')
        return
      }
      sessionStorage.setItem('surgeonIepOpenId', item.iepOpenId)
      sessionStorage.removeItem('selectCurrentJourney')
      sessionStorage.removeItem('journeyStage')
      if (`${item.customizedJourneyStatus}` === '1') {
        if (isUserRole) {
          this.$router.push({
            path: '/journeyPage',
            query: {
              customizedMultiCode: item.multiCode,
              // customizedCode: item.customizedJourneyId,
              isSurgeon: true
            },
          })
          return
        }
        this.customizedObj = item
        const _this = this
        this.cDialog = {
          title: '标题',
          visible: true,
          showCancelButton: true,
          cancelButtonText: '查看/编辑',
          confirmButtonText: '重新定制',
          content: '该术者已有定制CJ报告推送，是否需要重新定制',
          confirm: debounce(function () {
            _this.cDialog = {
              title: '提醒',
              visible: true,
              showCancelButton: true,
              cancelButtonText: '取消',
              confirmButtonText: '确认',
              content: '如您选择重新定制，之前定制的旅程数据会被重置，请确认是否需要继续',
              confirm: debounce(function () {
                _this.handleFun(_this.customizedObj)
              }, 500),
              cancel: () => {
                _this.cDialog.visible = false
              },
              close: () => {
                _this.cDialog.visible = false
              }
            }
          }, 500),
          cancel: () => {
            this.$router.push({
              path: '/journeyPage',
              query: {
                customizedMultiCode: this.customizedObj.multiCode,
                allowEditing: true
              // customizedCode: this.customizedObj.customizedJourneyId,
              },
            })
          },
          close: () => {
            this.cDialog.visible = false
          }
        }
      } else if (`${item.customizedJourneyStatus}` === '-1') {
        this.handleFun(item)
      } else {
        this.$router.push({
          path: '/selectiveDisease',
          query: {
            customizedMultiCode: item.multiCode,
            customizedCode: item.customizedJourneyId,
          },
        })
      }
    },
    handleFun(item) {
      let params = {
        multiCode: item.multiCode,
      }
      customizedChangeSuger(params).then((res) => {
        if (res.code === 0) {
          this.$router.push({
            path: '/selectiveDisease',
            query: {
              customizedMultiCode: item.multiCode,
              customizedCode: res.data,
            },
          })
        }
      })
    },
    clearSearchValue() {
      this.searchValue = ''
      this.postState = {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了',
      }
      this.employeeList = []
      this.handleEmployee()
    },
    onCourseSearchEnter: debounce(function () {
      this.postState = {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了',
      }
      this.employeeList = []
      this.handleEmployee()
    }, 400),
    handleEmployee() {
      let params = {
        pageNum: this.postState.pageNo,
        pageSize: this.postState.pageSize,
        email: this.isWhiteUser ? '' : this.userInfo.email, // 'XWang202@ITS.JNJ.com', //
        name: this.searchValue,
      }
      employeeHcp(params)
        .then((res) => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              this.isNone = false
              return false
            }
            this.postState.finished = false
            this.postState.loading = false
            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.employeeList = this.employeeList.concat(res.data.list)
            }
            this.postState.pageNo++
            setTimeout(() => {
              if (this.employeeList.length === 0) {
                this.isNone = false
                this.postState.finishText = ''
              } else if (this.employeeList.length > 0) {
                this.isNone = true
              }
            })
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.log('err:', err)
        })
      // const res = await getEmployeeHcp(this.searchValue)
      // this.employeeList = res.data.data
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.aifv-list {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;

  .aifv-div-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 64px;
    overflow: hidden;
    background: #F9F8F7;
  }

  /deep/ .van-search {
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px 10px;
    box-sizing: border-box;

    .van-search__content {
      border: 1px solid #F1EFED;
      background: rgba(255, 255, 255, 0.5);

      .van-field__control {
        color: #949BA5;
        font-weight: 400;
        font-size: 13px;
        &::placeholder {
          color: #949BA5;
          font-weight: 400;
          font-size: 13px;
        }
      }
    }
  }

  .img-btn {
    width: 103px;
    height: 38px;
    position: absolute;
    right: 10px;
    top: 11px;
  }

  .aifv-list-container {
    width: 100%;
    min-height: calc(100vh - 62px);
    background: #fff;
    border-radius: 8px 8px 0 0;
    box-shadow: inset 0px -1px 1px 0px rgba(255, 255, 255, 0.25);
    position: relative;
    top: 62px;
    padding-top: 16px;
    box-sizing: border-box;

    .item-container {
      display: flex;
      align-items: center;
      padding: 16px 26px;
      box-sizing: border-box;

      .item-cover {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 6px;
      }

      .item-info {
        flex: 1;

        .item-title {
          font-size: 14px;
          color: #000000;
          font-family: Source Han Sans CN, Source Han Sans CN;
          line-height: 20px;
          margin-bottom: 4px;
        }

        .item-tags {
          display: flex;
          align-items: center;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #7a8494;
          margin: 4px 0;
          .icon-tag {
            width: 30px;
            display: block;
            margin-right: 2px;
          }
        }

        .item-txt {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 12px;
          line-height: 20px;
          color: #7a8494;
        }
      }

      .arrow-btn {
        width: 70px;
        height: 24px;
        font-family: Helvetica, Helvetica;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: rgb(249, 248, 247);
        &.arrow-btn1 {
          color: #EB1700;
          border: 1px solid #EB1700;
        }
        &.arrow-btn2 {
          color: #2fbc57;
          border: 1px solid #2fbc57;
        }
        &.arrow-btn3 {
          color: #FF6017;
          border: 1px solid #FF6017;
        }
      }

      .item-arrow {
        width: 8px;
        display: block;
        margin-left: 2px;
      }
    }
  }

  .txts {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 21px;
    text-align: center;
    width: 270px;
    margin-top: 20px;
    margin-bottom: 36px;
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 200px;
  padding-bottom: 20px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/surgeonList.vue